import { z } from "zod";

const commaSeparatedEmails = z
  .string()
  .trim()
  .min(1, "At least one email address is required")
  .refine(
    (value) =>
      value
        .split(",")
        .map((email) => email.trim())
        .every(
          (email) =>
            email.length > 0 && z.string().email().safeParse(email).success,
        ),
    "All email addresses must be valid and separated by commas",
  )
  .transform((value) =>
    value
      .split(",")
      .map((email) => email.trim())
      .join(", "),
  );

export const sendEmailSchema = z.object({
  email: commaSeparatedEmails,
  cc: z.union([commaSeparatedEmails, z.literal("")]).optional(),
  subject: z.string().trim().min(1, "Subject is required").max(200),
  message: z.string().trim().min(1, "Message is required").max(10000),
});

export type SendEmail = z.infer<typeof sendEmailSchema>;
